import { Injectable, Injector } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AppConfigService } from '../services/app-config.service';
import { IomService } from '../services/iom.service';
import { SessionService } from '../services/session.service';

@Injectable()
export class AuthGuard implements CanActivate {
  envData: any = null;
  IOMService: any;  
  constructor(public envService: AppConfigService, private injector: Injector, private iomservice: IomService, private msalService: MsalService, private sessionService: SessionService) {

  }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.envData = this.envService.getEnvironment();    
    if (this.envData.AuthProvider == "AzureADAuthProvider") {
      let loggedUserName: string = this.sessionService.getUserName();
        if (this.envData.mslConfig.enableMSAL == true) {
            try {
                if (loggedUserName != null && loggedUserName != undefined) {
                    return true;
                }
                else {
                    const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
                    if (!isIE) {
                        this.msalService.loginRedirect();
                    } else {
                        this.msalService.loginPopup();
                    }
                    return false;
                }
            } catch (e) {
               // console.log('error');               
                return false;
            }
        }
        else {           
            return true;
        }
    }
    else if (this.envData.AuthProvider == "PAMAuthentication") {
      var flag = this.iomservice.isPAMAuthenticated();
      if ((flag == true)) {
        return true;
      }
      else {
        let currentUrl = window.location.href;
        window.location.href = encodeURI(this.envData.PAM_URL + this.Base64Encode("{'ReturnURl':'" + currentUrl + "'}"));
        return false;
      }
    }
    else {
      return true;
    }
  }
  Base64Encode(plainText: string) {
    return btoa(plainText);
  }
}
